import { TaxEstimateValidity } from "client/api-v2";
import type { OrderTaxEstimateDto } from "client/api-v2";

export const taxRateNotCalculated = "not calculated";

export function currentTaxEstimate(estimate: OrderTaxEstimateDto | null | undefined): OrderTaxEstimateDto | undefined {
  return estimate?.validity === TaxEstimateValidity.Valid ? estimate : undefined;
}

export function staleTaxEstimateReason(estimate: OrderTaxEstimateDto | null | undefined): string | undefined {
  switch (estimate?.validity) {
    case TaxEstimateValidity.AddressChanged:
      return "The billing address changed after this estimate was taken. Calculate again.";
    case TaxEstimateValidity.Unverifiable:
      return "This estimate can't be checked against the current billing address. Calculate again.";
    case TaxEstimateValidity.PriceChanged:
      return "The price changed after this estimate was taken. Calculate again.";
    default:
      return undefined;
  }
}

export function taxRateLabel(estimate: OrderTaxEstimateDto | undefined): string {
  if (!estimate) {
    return taxRateNotCalculated;
  }
  const net = estimate.estimatedTotalIncludingTax - estimate.estimatedTaxAmount;
  if (net <= 0) {
    return "rate unknown";
  }
  return `${Math.round((estimate.estimatedTaxAmount / net) * 1000) / 10}%`;
}
